module.exports = __webpack_public_path__ + "static/media/remove.1ea3c133.svg";